import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { service_url } from "./service-url";

@Injectable({
  providedIn: 'root'
})
export class AnnouncementService {

  api_url: any
  constructor(private http: HttpClient) {
    this.api_url = service_url.api_url
  }

  getAnnouncements(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/announcements', { params: params })
  }

  showAnnouncement(announcement_id) {
    return this.http.get(this.api_url + '/announcements/' + announcement_id)
  }

  submitAnnouncement(params, id = '') {
    if (id != '') {
      return this.http.put(this.api_url + '/announcements/' + id, params)
    }
    else {
      return this.http.post(this.api_url + '/announcements', params)
    }
  }

  deleteAnnouncement(announcement_id) {
    return this.http.delete(this.api_url + '/announcements/' + announcement_id)
  }

  getAnnouncementTypes(filters = {}) {
    let params = new HttpParams();
    Object.keys(filters).forEach(function (key) {
      params = params.append(key, filters[key]);
    });
    return this.http.get(this.api_url + '/announcement_types', { params: params })
  }
}
